export const contextToOptions = function () {
  let {
    version
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    context: {
      protocols: {
        event_version: version !== null && version !== void 0 ? version : 1
      }
    }
  };
};